import { WebsiteBlockDisplayItem } from '../api/WebsiteBlockDisplayItem';
import { WebsitePageDisplayItem } from '../api/WebsitePageDisplayItem';
import { WebsitePageInputItem } from '../api/WebsitePageInputItem';

declare module '../api/WebsitePageDisplayItem' {

    namespace WebsitePageDisplayItem {
        let ConvertToInputItem: typeof convertToInputItem;
    }
}

WebsitePageDisplayItem.ConvertToInputItem = convertToInputItem;

function convertToInputItem(displayItem: WebsitePageDisplayItem): WebsitePageInputItem {
    return new WebsitePageInputItem({
        Description: displayItem.Description,
        InMenu: displayItem.InMenu,
        Keywords: displayItem.Keywords,
        OrderIndex: displayItem.OrderIndex,
        RobotsIndex: displayItem.RobotsIndex,
        SEOTitle: displayItem.SEOTitle,
        Title: displayItem.Title,
        IsHomepage: displayItem.IsHomepage,

        WebsiteBlocks: displayItem.WebsiteBlocks?.map(block => WebsiteBlockDisplayItem.ConvertToInputItem(block)) ?? [],
        ChildWebsitePages: displayItem.ChildPages?.map(page => WebsitePageDisplayItem.ConvertToInputItem(page)) ?? [],
    });
}
